import React, { useEffect, useState } from 'react'
import Topbar from '../layouts/Topbar'
import PageHeader from '../components/PageHeader'
import SubHeader from '../components/SubHeader'
import CommonTable from '../components/Common_table'
import { useGlobalContext } from '../../context/Context';
import Addemployee from '../../Admin/components/Add_employee';
import Viewemployee from '../../Admin/components/View_employee'
import instance from '../../Utils/api'
import CircularProgress from '@mui/material/CircularProgress';
import Employeestatus from '../components/Employee_status'

const Employees = () => {

  const columns = [
    { label: "S.No", field: "sno", },
    { label: "Full Name", field: "employeeName", },
    { label: "Mobile No", field: "employeeMobile", },
    { label: "Email", field: "employeeEmail", },
    { label: "Role", field: "employeeRole", },
    { label: "Status", field: "Employeestatus", },
    { label: "Address", field: "employeeAddress", },
    { label: "Actions", field: "action", },
    // { label: "Employee Alternate number", field: "employeealtmobile",  },
    // { label: "Employee password", field: "employeepassword",  },
  ];
  const title = { name: "Employees", subheading: "Follow up with the employees", search: "Search employees", button: 'Add Employee' }
  const UserOptions = ['Active', 'Inactive'];
  const EmployeeRoleOptions = ['None', 'JuniorDesigner', 'SeniorDesigner',];
  // 'Tailor'
  const SortOptions = ['None', 'name', 'mobile', 'createdAt']
  //usestate define
  const { loading, setLoading } = useGlobalContext();
  const { openDialog, setOpenDialog } = useGlobalContext();
  const { openviewDialog, setopenviewDialog } = useGlobalContext();
  const { statusDialog, setstatusDialog } = useGlobalContext();
  const [edit, setEdit] = useState(false);
  const [admins, setAdmins] = useState([]);
  const [employees, setEmployees] = useState(false)
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [totalpages, setTotalPages] = useState();
  const [currentPage, setCurrentPages] = useState(1);
  const [totalCount, setTotalcount] = useState();
  const [search, setSearch] = useState();
  const [userStatus, SetUserStatus] = useState();
  const [role, SetRole] = useState()
  const [sortstatus, setSortStatus] = useState();
  const rowsperpage = 10;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleCloseFilter = () => setAnchorEl(null);

  //fetch admins
  const fetchadmins = async () => {
    const params = {
      search,
      page: currentPage,
      limit: rowsperpage,
      // sortBy: "createdAt",
      // sortOrder: "desc",
      ...(userStatus && userStatus !== 'None' ? { status: userStatus } : {}),
      ...(role && role !== 'None' ? { role: role } : {}),
      ...(sortstatus && sortstatus !== 'None' ? { sortBy: sortstatus } : {}),

    }
    try {
      const response = await instance.get('/Admin/getAdmins', { params })
      const formatteddata = response?.data?.data?.map((employee, index) => ({
        sno: index + 1,
        employeeName: employee?.name ? employee?.name : "---",
        employeeMobile: employee?.mobile ? employee?.mobile : "---",
        employeeEmail: employee?.email ? employee?.email : "---",
        employeeRole: employee?.role ? employee?.role : "---",
        Employeestatus: employee?.status === true ? "Active" : "Inactive",
        employeeAddress: employee?.address ? employee?.address : "---",
        employeealtmobile: employee?.alt_mobile ? employee?.alt_mobile : "---",
        employeepassword: employee?.password ? employee?.password : "---",
        employeeId: employee?._id ? employee?._id : "---",
        profile_pic: employee?.profile_pic ? employee?.profile_pic : '---',
      }))

      setAdmins(formatteddata);
      setTotalPages(response?.data?.totalPages);
      setCurrentPages(response?.data?.currentPage);
      setTotalcount(response?.data?.total);
    }
    catch (error) {
      console.log("error to fetch admins:", error.message)
    } finally {
      setLoading(false);
    }

  }

  useEffect(() => {
    fetchadmins(search, currentPage, rowsperpage, sortstatus, role, userStatus);
    setEmployees(false)
    setLoading(true);
  }, [employees, search, currentPage, rowsperpage])


  // Handle Row Click for Edit
  const handleEditClick = (employee) => {
    setSelectedEmployee(employee);
    setEdit(true);
    setOpenDialog(true);
  };

  // Handle Row Click for view
  const handleViewClick = (employee) => {
    setSelectedEmployee(employee);
    setopenviewDialog(true)
  }

  const handleEmpolyeestatusClick = (employee) => {
    setSelectedEmployee(employee);
    setstatusDialog(true)
  }
  //filter function open menu
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Apply Filter Handler
  const handleEmployeeApplyFilter = () => {
    fetchadmins(search, currentPage, rowsperpage, sortstatus, role, userStatus);
    setAnchorEl(null);

  };

  const handleClearFilter = () => {
    SetUserStatus("");
    SetRole("");
    setSortStatus("");
    setSearch("");
    setCurrentPages(1);
    handleCloseFilter();
    setEmployees(true);
  };


  return (
    <>
      <Topbar />
      <section className='admin-catalogue'>
        <PageHeader
          title={title}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          setSearch={setSearch}
        />
        <SubHeader
          isField={'employees'}
          menu={false}
          filter={true}
          isVisible={true}
          isEmployeepage={true}
          anchorEl={anchorEl}
          open={open}
          handleClick={handleClick}
          handleCloseFilter={handleCloseFilter}
          handleEmployeeApplyFilter={handleEmployeeApplyFilter}
          handleClearFilter={handleClearFilter}
          UserOptions={UserOptions}
          userStatus={userStatus}
          SetUserStatus={SetUserStatus}
          sortstatus={sortstatus}
          setSortStatus={setSortStatus}
          SortOptions={SortOptions}
          role={role}
          SetRole={SetRole}
          EmployeeRoleOptions={EmployeeRoleOptions}
        />
        {loading ?
          <div className='loader-section'>
            <CircularProgress />
          </div>
          :
          <CommonTable
            columns={columns}
            rows={admins}
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            openviewDialog={openviewDialog}
            setopenviewDialog={setopenviewDialog}
            edit={edit}
            setEdit={setEdit}
            handleEditClick={handleEditClick}
            handleViewClick={handleViewClick}
            banner={true}
            menu={true}
            totalpages={totalpages}
            rowsperpage={rowsperpage}
            totalCount={totalCount}
            currentPage={currentPage}
            setCurrentPages={setCurrentPages}
            handleEmpolyeestatusClick={handleEmpolyeestatusClick}
            handleClearFilter={handleClearFilter}
            handleCloseFilter={handleCloseFilter}
          />
        }
        <Viewemployee
          openviewDialog={openviewDialog}
          setopenviewDialog={setopenviewDialog}
          selectedEmployee={selectedEmployee}
        />
        <Addemployee
          edit={edit}
          setEdit={setEdit}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          selectedEmployee={selectedEmployee}
          setEmployees={setEmployees}
        />
        <Employeestatus
          statusDialog={statusDialog}
          setstatusDialog={setstatusDialog}
          selectedEmployee={selectedEmployee}
          setEmployees={setEmployees}
        />
      </section>
    </>
  )
}

export default Employees
